import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-container">
        <h1 className="privacy-title">Sun King App - Privacy Policy</h1>

        <div className="privacy-content">
          <p>
            <strong>Effective Date: December 1, 2025</strong>
          </p>

          <p>
            Sun King ("we", "us", "our") is committed to protecting your privacy
            and handling your personal data in accordance with the Kenya Data
            Protection Act, 2019 and the Data Protection (General) Regulations,
            2021.
          </p>

          <p>
            This Privacy Policy explains how we collect, use, share, store, and
            protect your personal data when you use the Sun King mobile
            application ("App").
          </p>

          <p>
            By using the App, you acknowledge that you have read and understood
            this Privacy Policy.
          </p>

          <h2>1. Who We Are (Data Controller Information)</h2>
          <p>
            <strong>Data Controller:</strong> Greenlight Planet Kenya Limited
          </p>
          <p>
            <strong>Registered Address:</strong> Greenlight Planet Kenya
            Limited, 2nd Floor, Priory Place, Argwings Kodhek Road, Kilimani,
            Nairobi.
          </p>
          <p>
            <strong>Email:</strong> carekenya@sunking.com
          </p>
          <p>
            <strong>Phone:</strong> +254 800 724 878
          </p>
          <p>
            <strong>Data Protection Officer (DPO):</strong>
          </p>
          <p>
            <strong>Email:</strong> joseph.mugera@sunking.com
          </p>

          <h2>2. What Personal Data We Collect</h2>
          <p>We collect the following categories of personal data:</p>

          <h3>2.1 Personal Identification Data</h3>
          <ul>
            <li>Full name</li>
            <li>Phone number</li>
            <li>Email address</li>
            <li>Address</li>
            <li>National ID or other government-issued documents</li>
            <li>Date of birth</li>
            <li>Gender</li>
          </ul>
          <br />
          <h3>2.2 Financial Information</h3>
          <ul>
            <li>Mobile money transaction history</li>
            <li>Product payments and balances</li>
            <li>Linked bank or wallet account details (if applicable)</li>
          </ul>
          <br />

          <h3>2.3 Device & Usage Data</h3>
          <ul>
            <li>Mobile device model and operating system</li>
            <li>IP address</li>
            <li>
              App usage behaviour (screens visited, clicks, features used)
            </li>
            <li>Location data (only with your consent)</li>
          </ul>
          <br />

          <h3>2.4 Customer Support Interactions</h3>
          <ul>
            <li>Chats or Calls with Customer care</li>
            <li>Responses to surveys or offers</li>
          </ul>

          <h2>3. Legal Basis for Processing Your Data</h2>
          <p>We process your data based on the following lawful bases:</p>

          <h3>3.1 Consent</h3>
          <ul>
            <li>Location access</li>
            <li>Marketing messages</li>
            <li>Access to device permissions</li>
          </ul>
          <p>
            Where required by law, we will only process your data after
            obtaining your specific, informed, and unambiguous consent. You will
            be asked to actively agree before we access device permissions, send
            marketing messages, or use optional features.
          </p>
          <p>
            You can withdraw your consent at any time through your device
            settings, App profile, or by contacting through the "Help" section
            of the App. We keep records of the consents you provide.
          </p>

          <h3>3.2 Performance of a Contract</h3>
          <ul>
            <li>Identity verification</li>
            <li>Credit eligibility assessment</li>
            <li>Loan processing and repayments</li>
          </ul>
          <br />

          <h3>3.3 Compliance with Legal Obligations</h3>
          <ul>
            <li>Regulatory reporting</li>
            <li>Tax and audit requirements</li>
            <li>Credit bureau submissions (if required by law)</li>
          </ul>
          <br />

          <h3>3.4 Legitimate Interests</h3>
          <ul>
            <li>Fraud detection</li>
            <li>System improvement</li>
            <li>Customer support</li>
            <li>Service analytics</li>
          </ul>

          <h2>4. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Create and manage your customer account</li>
            <li>Verify your identity and eligibility for credit products</li>
            <li>Process loan applications and payments</li>
            <li>Monitor your repayment behaviour</li>
            <li>Send reminders, offers, and important updates</li>
            <li>Improve app features and user experience</li>
            <li>Detect fraud and ensure system security</li>
          </ul>

          <h2>5. Automated Decision-Making & Credit Scoring</h2>
          <p>
            Some decisions, such as assessing your creditworthiness, may be made
            through automated systems.
          </p>
          <p>You have the right to:</p>
          <ul>
            <li>Request human intervention</li>
            <li>Contest an automated decision</li>
            <li>Request an explanation of how the decision was made</li>
          </ul>

          <h2>6. Who we share your Personal Data with</h2>
          <p>
            We do not sell your personal data. However, we may share your data
            with:
          </p>

          <h3>6.1 Service Providers</h3>
          <ul>
            <li>Mobile money or bank partners to process your payments</li>
            <li>
              Customer support platforms like Zendesk for issue resolution
            </li>
            <li>Cloud hosting and IT service providers</li>
          </ul>
          <br />

          <h3>6.2 Regulatory & Legal Authorities</h3>
          <ul>
            <li>Credit bureaus (if legally required)</li>
            <li>Law enforcement agencies</li>
            <li>Government ministries or regulators</li>
          </ul>
          <br />

          <h3>6.3 Internal Authorized Personnel</h3>
          <ul>
            <li>Employees and field agents involved in service delivery</li>
          </ul>
          <p>
            All third parties are contractually required to follow strict
            confidentiality and data protection rules.
          </p>
          <br />

          <h2>7. Cross-Border Data Transfers</h2>
          <p>
            Some of our service providers may store or process your data outside
            Kenya.
          </p>
          <p>
            When this happens, we ensure that your data is transferred only to
            countries that provide adequate data protection or through:
          </p>
          <ul>
            <li>Standard contractual clauses</li>
            <li>Data processing agreements</li>
            <li>Other ODPC-approved safeguards</li>
          </ul>

          <h2>8. Your Rights as a Data Subject</h2>
          <p>Under the Kenya DPA, you have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction or update</li>
            <li>Request deletion (where legally permitted)</li>
            <li>Object to processing</li>
            <li>Restrict processing</li>
            <li>Data portability</li>
            <li>Withdraw consent at any time</li>
            <li>Lodge a complaint with ODPC</li>
          </ul>
          <p>
            You may exercise these rights through the "Help" section of the App.
          </p>

          <h2>9. Data Retention</h2>
          <p>
            We retain your data only for as long as you have active credit
            products with us.
          </p>
          <p>
            <strong>Retention Periods</strong>
          </p>
          <ul>
            <li>
              Up to 7 years after product closure (as required by law or audits)
            </li>
            <li>Support tickets and call recordings: 3 years</li>
            <li>Marketing consent records: Until consent is withdrawn</li>
          </ul>
          <p>
            If you request deletion, we will delete data unless retention is
            required for:
          </p>
          <ul>
            <li>Legal, regulatory, tax, audit, or compliance purposes</li>
          </ul>

          <h2>10. Data Security</h2>
          <p>
            We implement appropriate technical and organisational controls,
            including:
          </p>
          <ul>
            <li>Encryption in transit and at rest</li>
            <li>Access controls and role-based access</li>
            <li>Secure data storage</li>
            <li>Regular security assessments</li>
            <li>Incident detection and response</li>
          </ul>
          <p>
            Despite these measures, no system is fully secure. We will notify
            you and the ODPC of any data breach as required by law.
          </p>

          <h2>11. Children's Privacy</h2>
          <p>
            The App is not intended for persons under 18 years. We do not
            knowingly collect children's data.
          </p>
          <p>If a child has provided data, we will delete it upon request.</p>

          <h2>12. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes
            will be shared in-app or via SMS. Your continued use of the App
            constitutes acceptance of the updated policy.
          </p>

          <h2>13. Contact Us</h2>
          <p>For questions, concerns, or to exercise your rights:</p>
          <p>
            <strong>
              Data Protection Officer – Greenlight Planet Kenya Private Limited
            </strong>
          </p>
          <p>
            <strong>Email:</strong> joseph.mugera@sunking.com
          </p>
          <p>
            <strong>Phone:</strong> +254 800 724 878
          </p>
          <p>
            <strong>Address:</strong> Greenlight Planet Kenya Limited, 2nd
            Floor, Priory Place, Argwings Kodhek Road, Kilimani, Nairobi.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
